module.exports = __webpack_public_path__ + "static/media/content_review.0d15f8ac.png";